import styled, { css } from 'styled-components';

export const ScriptBody = styled.ul`
	width: 100%;
`;

export const ElementContainer = styled.li`
	width: 100%;
	list-style: none;
	display: flex;
	margin-bottom: ${({ isHided }) => (isHided ? 0 : '4px')};

	${({ isHided }) =>
		isHided &&
		css`
			height: 0 !important;

			& * {
				opacity: 0 !important;
				height: 0 !important;
				pointer-events: none !important;
			}
		`}

	& > button {
		margin-left: 4px;
		width: 50px;
		height: auto;
	}

	${({ isNewBlock }) =>
		isNewBlock &&
		css`
			margin-top: 16px;
		`}

	&:first-child {
		margin-top: 0 !important;
	}
`;

export const RadioVignetteOpContent = styled.div`
	width: 100%;
	display: flex;
	flex-direction: column;

	& > div {
		margin-top: -5px;
		display: flex;
		gap: 12px;
	}
`;

export const ElementContent = styled.div`
	background: ${({ color }) => color};
	/* height: ${({ compact, isRecPlay }) => (isRecPlay ? '50px' : compact ? '30px' : '50px')}; */
	flex: 1;
	flex-direction: column;
	display: flex;
	align-items: center;
	justify-content: space-between;
	box-shadow: 0px 0px 0px 1px
		${({ color }) => (!color || color.startsWith('#FFF') ? '#b7b7b7' : color)};
	border: 1px solid #fff;
	padding: 12px;
	border-radius: var(--border-radius-base);
	cursor: ${({ _disabled }) => (_disabled ? 'not-allowed' : 'grab')};
	transition: height 300ms;

	${({ isInactive }) =>
		isInactive &&
		css`
			opacity: 0.2;
		`}

	& > div.main-part {
		width: 100%;
		display: flex;
		align-items: center;
		justify-content: space-between;

		& > div.element-infos {
			display: flex;
			align-items: center;
			gap: 16px;

			& > svg {
				font-size: 20px;
			}

			& > div.placeholder {
				height: 100%;
				display: flex;
				flex-direction: column;
				justify-content: center;

				& > p {
					font-size: 13px;
					font-weight: 600;
					margin: 0;
				}

				& > span.option {
					font-size: 12px;
					margin-top: -2px;
					opacity: 0.9;
				}
			}
		}

		& > span.index-label {
			font-size: 12px;
			color: #fff;
			opacity: 0.8;
		}
	}

	& * {
		color: ${({ color }) => (!color || color.startsWith('#FFF') ? '#040404' : '#FFF')};
	}

	${({ _disabled }) =>
		_disabled &&
		css`
			opacity: 0.5;
		`}
`;

export const RecplaySubparts = styled.div`
	width: 100%;
	display: flex;
	flex-direction: column;
	gap: 4px;
	margin-top: 8px;

	& > ul {
		width: 100%;
		display: flex;
		flex-direction: column;
		padding-left: 36px;
		transition: 150ms;

		& > li {
			position: relative;
			list-style: disc;
			font-size: 12px !important;
			font-weight: 400;
			font-style: italic;
			padding: 2px 0;

			&::before {
				content: '';
				position: absolute;
				background: #fff;
				top: 16px;
				left: -14px;
				width: 2px;
				height: 12px;
			}

			&:last-child::before {
				display: none !important;
			}
		}
	}
`;
